<template>
  <div class="btn-group-vertical d-block">
    <button
      v-for="(object, index) in options"
      :key="index"
      @click="addRemoveObject(object)"
      type="button"
      :class="selectedObjects.indexOf(object) !== -1 ? 'active ' : ''"
      class="btn btn-dark text-left px-4"
      autocomplete="off"
    >
      {{ titleField ? object[titleField] : index }}
    </button>
    <div class="px-1 mb-1">
      <a href="#" @click.prevent="pickingDone()">
        <div class="bg-gray text-center text-primary clickable rounded px-4 py-3">{{$t('Select')}}</div>
      </a>
    </div>
  </div>
</template>

<script>
export default {

  name: 'ObjectMultiSelect',

  props: {
    preSelected: { default: [] },
    options: { default: [] },
    onChange: Function,
    onPickingDone: Function,
    titleField: String
  },

  created () {
    this.selectedObjects = this.preSelected
  },

  data () {
    return {
      selectedObjects: []
    }
  },

  methods: {
    pickingDone () {
      if (this.onPickingDone) { this.onPickingDone(this.selectedObjects) }
    },
    addRemoveObject (object) {
      const indexOf = this.selectedObjects.indexOf(object)
      if (indexOf === -1) {
        this.selectedObjects.push(object)
      } else {
        this.selectedObjects.splice(indexOf, 1)
      }
      this.selectedObjects = Array.from(this.selectedObjects)
      if (this.onChange) { this.onChange(this.selectedObjects) }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/shared/ObjectMultiSelect.vue